export const contactInfo = {
  address: ` 33 Lorem ipsum dolor sit \n 3235 amet consectetur \n adipisicing.`,
  phone: 'Call us: 123 564 7789',
  working: 'We are working from \n Tuesday - Sunday \n 12:00 - 23:00',
  social: {
    facebook: 'facebook',
    instagram: 'instagram',
    youtube: 'youtube',
  },
};
